import { useAuth0 } from "@auth0/auth0-react";
import { LoadingButton } from "@mui/lab";
import {
    Alert,
    Divider,
    Paper,
    Stack,
    Typography
} from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../redux";
import { openDialog } from "../../redux/slices/dialog";
import { AppRoutes } from "../../router/routes";
import { LocalStorageKeys } from "../../utils";
import { Timeout } from "../timeout";

const Login: React.FC = (props) => {
  const navigate = useNavigate();
  const { loginWithRedirect } = useAuth0();
  const { isError, message } = useAppSelector((state) => state.auth);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [params] = useSearchParams();
  const dispatch = useAppDispatch();

  React.useEffect(() => {
    if (localStorage.getItem(LocalStorageKeys.authToken)) {
      navigate(AppRoutes.home);
    }
  });

  useEffect(() => {
    if (params.get('page') === 'timeout') {
      dispatch(
        openDialog({
          title: "",
          hideNegativeBtn: true,
          hidePositiveBtn: true,
          hideCloseIcon: true,
          body: <Timeout />,
        })
      );
    }
    // eslint-disable-next-line
  }, [])

  if (params.get('page') === 'timeout') {
    return <></>;
  }
  

  return (
    (<Box
      sx={{
        display: "flex",
        height: "100%",
        alignItems: "center",
        justifyContent: "center"
      }}>
      <Paper
        variant="outlined"
        sx={{ width: { xs: "300px", sm: "400px" }, padding: 4 }}
      >
        <Stack spacing={4} sx={{
          alignItems: "center"
        }}>
          <Stack
            direction={"row"}
            spacing={1}
            sx={{
              alignItems: "center",
              mb: 2
            }}>
            <img src="/logo.jpg" style={{ height: "64px" }} alt="logo" />
          </Stack>

          {!isError && (
            <LoadingButton
              id="loginBtn"
              startIcon={
                <Stack direction={"row"} sx={{ mr: 1 }}>
                  <img
                    src={"/office.png"}
                    alt="office 365 logo"
                  />
                  {!isLoading && (
                    <Divider
                      variant="fullWidth"
                      sx={{ borderColor: "white !important", borderWidth: 1 }}
                    />
                  )}
                </Stack>
              }
              variant="contained"
              onClick={() => {
                loginWithRedirect();
                setIsLoading(true);   
              }}
              loading={isLoading}
              sx={{
                textTransform: "none",
                bgcolor: "red !important",
                fontSize: 18,
                pl: 0,
                ".MuiLoadingButton-loadingIndicator": {
                  color: "white",
                },
              }}
            >
              Login with Office 365
            </LoadingButton>
          )}

          {!isError && (
            <Typography
              variant="body1"
              color="textSecondary"
              sx={{ fontWeight: "600" }}
            >
              For Enterprise Customers Only
            </Typography>
          )}

          {isError && <Alert severity="error">{message}</Alert>}

          {isError && (
            <LoadingButton
              variant="outlined"
              color="warning"
              onClick={() => navigate(AppRoutes.logout)}
            >
              Logout
            </LoadingButton>
          )}
        </Stack>
      </Paper>
    </Box>)
  );
};

export default Login;